import React from "react";
import StartSmartFAQ from "./StartSmartFAQ";
import CTAButtons from "../ReuasbleComponets/CTAButtons";
import TrustedCompanies from "../ReuasbleComponets/TrustedCompanies";
import StartSmartPricing from "./SmartStartPricing";
import Leadmagnet from "../ReuasbleComponets/leadmagnet";

const StartSmartCampaign = () => {
  const steps = [
    {
      id: 1,
      title: "Choose a number",
      image: "./../assets/images/StartSmart/Select-a-local-number.gif",
    },
    {
      id: 2,
      title: "Activate  Instantly ",
      image: "./../assets/images/StartSmart/doctor-making-use-of-nxatel.webp",
    },
    {
      id: 3,
      title: "Start  calling, and messaging  professionally",
      image: "./../assets/images/StartSmart/Answer-a-call-GIF.gif",
    },
  ];
  const imageCards = [
    {
      src: "./../assets/images/StartSmart/nxatel-dashboard.webp",
      alt: "Person making use of Nxatel Dashboard",

      description: "One number. One inbox. Everyone aligned",
    },
    {
      src: "./../assets/images/StartSmart/users-messaging-using-nxatel.webp",
      alt: "A group messaging on Nxatel app",

      description: "Your business number works wherever your team works",
    },
    {
      src: "./../assets/images/StartSmart/start-smart-business-call.webp",
      alt: "A Client making use of Nxatel to conduct Business",

      description: "WhatsApp, SMS, and calls — finally in one dashboard",
    },
  ];
  const items = [
    {
      icon: "./../assets/images/StartSmart/callerid.svg",
      title: "Business Caller ID",
    },
    {
      icon: "./../assets/images/StartSmart/message.svg",
      title: "SMS Messaging",
    },
    {
      icon: "./../assets/images/StartSmart/mobile.svg",
      title: "Manage your office communication on the go with our Mobile App",
    },
    {
      icon: "./../assets/images/StartSmart/whatsapp.svg",
      title: "Shared WhatsApp Inbox",
    },
    {
      icon: "./../assets/images/StartSmart/team extension.svg",
      title: "Team Extensions",
    },
    {
      icon: "./../assets/images/StartSmart/business icon.svg",
      title: "Connect your Business WhatsApp line",
    },
  ];
  const testimonials = [
    {
      initials: "CS",
      name: "Charles S",
      title: "HAPPY CLIENT – REMARKABLE WORK",
      review:
        "Nxatel - Their service and installation was excellent and the phone system up and running with excellent service. I thank them for their good service.",
      rating: 5,
      source: "./../assets/images/new_about_us/hellopeter_review.webp",
      link: "https://www.hellopeter.com/nxatel/reviews/happy-client-remarkable-work-5092537#",
    },
    {
      initials: "P",
      name: "Pamela Annandale",
      role: "Local Guide",
      review:
        "Service excellent. Whenever we encounter problems, Nxatel are on it immediately. Call back to ensure that we are up and running. Ellis Singer Verspreiders (Pty) Ltd are happy clients of Nxatel.",
      rating: 5,
      source: "./../assets/images/new_about_us/google_review.webp",
      link: "https://g.co/kgs/d3LVBtS",
    },
    {
      initials: "MH",
      name: "md H",
      role: "East End General Dealer",
      review:
        "Nxatel has given me the best service so far we started out rocky but we ended up getting it right am happy with the service.",
      rating: 5,
      source: "./../assets/images/new_about_us/hellopeter_review.webp",
      link: "https://www.hellopeter.com/nxatel/reviews/east-end-general-dealer-5100603",
    },
  ];

  return (
    <>
      {/* Start Smart Campaign Hero */}

      <section className="StartSmart-Hero">
        <div className="StartSmart-Hero__content">
          <h1>
            Start <span>Smart .</span> Look <span>professional</span> from day
            one.
          </h1>
          <p>
            Get your business caller ID, professional Number and shared inbox
            all in one app. Active in 3 minutes. No hardware. No contracts
          </p>
          <div className="StartSmart-Hero-button">
            <a
              href="/signup"
              className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0 pt--10 pb--10 pr--20 pl--20"
            >
              Try For Free
            </a>
          </div>
        </div>
        <div className="StartSmart-Hero__image">
          <img
            className="devices_app"
            src="./../assets/images/StartSmart/smart-start-phone-dashboard.webp"
            alt="Business phone dashboard and caller ID on NxaTel platform"
            loading="lazy"
          />
        </div>
      </section>
      {/* trusted */}
      <section className="StartSmart-Trusted">
        <TrustedCompanies />
        <p className="StartSmart-Trusted-desc">
          No contract. No set-up Fees. One Provider for everything. Easy to
          scale. Work from Home Ready​
        </p>
      </section>
      <div className="backgroundwhite">
        {/* Personal Number */}
        <section className="start-smart-personal">
          <div className="start-smart-personal__image">
            <img
              className="start-smart-personal__call"
              src="./../assets/images/StartSmart/PersonalNumber.webp"
              alt="Man stressed because of multiple sim cards needed to run business"
              loading="lazy"
            />
          </div>
          <div className="start-smart-personal__content">
            <h1>
              Is your <span>personal number</span> costing you{" "}
              <span className="highlight">credibility</span>
            </h1>
            <p>
              If you are about to launch, submit proposals or print your first
              business card, you can’t afford to look unprepared. Make your
              first impression with a professional number.
            </p>
          </div>
        </section>
        {/* Starting Business */}
        <section className="start-smart__business">
          <div className="start-smart__heading">
            Starting your business should{" "}
            <span className="start-smart__highlight">feel Smart</span> - not
            small
          </div>

          <p className="start-smart__description">
            Nxatel has built a smart start solution to give entrepreneurs a
            professional communication tool that grows with them from day one.
          </p>

          <div className="start-smart__image-container">
            <img
              src="./../assets/images/StartSmart/business-call-app-on-mobile.webp"
              alt="Business call app interface on mobile and desktop"
              className="start-smart__image"
            />
          </div>

          <div className="start-smart__cta">
            <CTAButtons />
          </div>
        </section>
      </div>
      {/* Pay Smart Pricing */}
      <StartSmartPricing />
      {/* What you get */}
      <section className="what-you-get">
        <div className="what-you-get__container">
          <h2 className="what-you-get__title">What You Get</h2>
          <p className="what-you-get__subtitle">
            Your business number. Plus everything you need to scale up
          </p>
          <div className="what-you-get__grid">
            {items.map((item, index) => (
              <div className="what-you-get__item" key={index}>
                <div className="what-you-get__icon-wrapper">
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="what-you-get__icon"
                  />
                </div>
                <p className="what-you-get__text">{item.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Get Started */}
      <section className="Start-Smart-get-started-section">
        <div className="header">
          <h1>Get Started with NxaTel in Just 3 Minutes</h1>
          <p>
            No waiting. No complicated setup. Just plug, play, and start
            calling!
          </p>
        </div>
        <div className="Start-Smart-get-started-container">
          {steps.map((step) => (
            <div key={step.id} className="Start-Smart-get-started-card">
              <div className="Start-Smart-get-started-number">{step.id}</div>
              <img
                src={step.image}
                alt={step.title}
                className="Start-Smart-get-started-image"
              />
              <h2>{step.title}</h2>
            </div>
          ))}
        </div>
      </section>
      {/* Start Smart Future Clients */}
      <section className="start-smart-future">
        <div className="start-smart-future__image">
          <img
            className="start-smart-future__call"
            src="./../assets/images/StartSmart/startup-pitch-with-business-number.webp"
            alt="Startup founder preparing pitch with NxaTel business number"
            loading="lazy"
          />
        </div>
        <div className="start-smart-future__content">
          <h1>
            <span>Start Smart:</span> Your future clients are watching
          </h1>
          <p>
            Choose your business number. Activate your line. Start with
            confidence.
          </p>
          <div className="start-smart-future__button">
            <a
              href="/signup"
              className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0 pt--10 pb--10 pr--20 pl--20"
            >
              Start Smart Today
            </a>
          </div>
        </div>
      </section>
      <div className="backgroundwhite">
        {/* Testimonials */}
        <section className="Smart-Start-testimonial">
          <h1 className="Smart-Start-testimonial__heading">
            Smart startups choose
            <span className="Smart-Start-testimonial__underline"> Nxatel </span>
          </h1>
          <p className="Smart-Start-testimonial__text">
            Real business owners. Real results
          </p>
          <div className="Smart-Start-testimonial_container ">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="Smart-Start-testimonial-card">
                {/* User Info */}
                <div className="Smart-Start-testimonial-card__header">
                  <div className="Smart-Start-testimonial-card__avatar">
                    {testimonial.initials}
                  </div>
                  <div>
                    <h3 className="Smart-Start-testimonial-card__name">
                      {testimonial.name}
                    </h3>
                    {testimonial.role && (
                      <p className="Smart-Start-testimonial-card__role">
                        {testimonial.role}
                      </p>
                    )}
                  </div>
                </div>

                {/* Review Content */}
                <div className="Smart-Start-testimonial-card__content">
                  <h4 className="Smart-Start-testimonial-card__title">
                    {testimonial.title}
                  </h4>
                  <p className="Smart-Start-testimonial-card__text">
                    {testimonial.review}
                  </p>
                </div>

                {/* Rating & Source */}
                <div className="Smart-Start-testimonial-card__footer">
                  <div className="Smart-Start-testimonial-card__stars">
                    ⭐️⭐️⭐️⭐️⭐️
                  </div>
                  <a href={testimonial.link}>
                    {" "}
                    <p className="Smart-Start-testimonial-card__source">
                      {testimonial.rating}.0 Review from{" "}
                      <img src={testimonial.source} />
                    </p>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
        {/* Built for Startups/side hustles... */}
        <section className="Start-smart-Build">
          <h1 className="Start-smart-Build__title">
            Who is Smart
            <span>Start built for?</span>
          </h1>
          <p className="Start-smart-Build__subtitle">
            Whether you’re launching or scaling, Smart Start gives your team the
            tools to connect, communicate, and grow with credibility
          </p>

          <div className="Start-smart-Build__cards">
            {imageCards.map((card, index) => (
              <div className="Start-smart-Build__card" key={index}>
                <img
                  className="Start-smart-Build__card-image"
                  src={card.src}
                  alt={card.alt}
                />

                <p className="Start-smart-Build__card-description">
                  {card.description}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>
      {/* Lead Magnet */}
      <Leadmagnet />
      {/* FAQ */}
      <StartSmartFAQ />
      {/* Let your bussiness */}
      <section className="start-smart-let">
        <div className="start-smart-let__image">
          <img
            className="start-smart-let__call"
            src="./../assets/images/StartSmart/happy-customers-using-nxatel.webp"
            alt="Happy customer using Nxatel to conduct Business and take calls"
            loading="lazy"
          />
        </div>
        <div className="start-smart-let__content">
          <h1>
            Let your number say, <span>“We’re in business” </span>{" "}
          </h1>
          <p>
            Make your first impression count. Activate your business line in
            just 3 minutes and start with clarity.
          </p>
          <div className="start-smart-let__button">
            <a
              href="/signup"
              className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0 pt--10 pb--10 pr--20 pl--20"
            >
              Start For Free now
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default StartSmartCampaign;
